import { Injectable } from '@angular/core';
import { TableColumnService } from '../services/table-column.service';
import { TableColumnProvider } from '../../../interfaces/table-column-provider';
import { TableColumn } from '../../../models/table-column';
import { AddressBook } from '../../../models/address-book';
import { EntityEnum } from '../../../enum/entity.enum';

@Injectable({
    providedIn: 'root'
})
export class AddressBookColumnsService implements TableColumnProvider {

    public readonly ADDRESS_BOOK_NAME = 'ADDRESS_BOOK_NAME';
    public readonly ADDRESS_BOOK_DESCRIPTION = 'ADDRESS_BOOK_DESCRIPTION';
    public readonly ADDRESS_BOOK_VISIBILITY = 'ADDRESS_BOOK_VISIBILITY';

    constructor(private tableColumnService: TableColumnService) {
        this.tableColumnService.registerProvider(this);
    }

    get(id: string): TableColumn {
        switch (id) {
            case this.ADDRESS_BOOK_NAME:
                return {
                    id: this.ADDRESS_BOOK_NAME,
                    caption: $localize`Name`,
                    width: 150,
                    render: (addressBook: AddressBook) => addressBook.name
                };
            case this.ADDRESS_BOOK_DESCRIPTION:
                return {
                    id: this.ADDRESS_BOOK_DESCRIPTION,
                    caption: $localize`Description`,
                    width: 200,
                    render: (addressBook: AddressBook) => addressBook.description
                };
            case this.ADDRESS_BOOK_VISIBILITY:
                return {
                    id: this.ADDRESS_BOOK_VISIBILITY,
                    caption: $localize`Visibility`,
                    width: 100,
                    render: (addressBook: AddressBook) => addressBook.visibility
                };
        }
    }

    ids(): string[] {
        return [ this.ADDRESS_BOOK_NAME, this.ADDRESS_BOOK_DESCRIPTION, this.ADDRESS_BOOK_VISIBILITY ];
    }

    supports(entityClass: string): boolean {
        return entityClass === EntityEnum.ADDRESS_BOOK;
    }
}
